import { useUserStore } from '@/features/account/services/User/hooks'
import { useQueryRewardsPrograms } from '@/features/account/services/RewardsPrograms/queries'
import {
  type LoyaltyFieldValues,
  type LoyaltyProgram,
  type ProgramPayload,
} from '@/features/account/services/RewardsPrograms/types'

export const useCurrentStoreProgram = () => {
  const shoppingStore = useUserStore()
  const { data } = useQueryRewardsPrograms()
  if (!data) return

  const { available_programs, current_programs } = data
  const programs = [...current_programs, ...available_programs]
  return programs.find((program) => program.store.id === shoppingStore?.id)
}

export const createProgramPayload = (
  program: LoyaltyProgram,
  fieldsByKey: Record<string, LoyaltyFieldValues>,
): ProgramPayload => ({
  id: program.id,
  loyalty_type_id: program.loyalty_type_id,
  loyalty_field_values_attributes: Object.values(fieldsByKey),
})
